import { Typography } from '@repo/ui';
import { parseDate } from '@repo/utils';
import { format } from 'date-fns';
import { MicrobiomeAgeSample } from 'services/microbiome/types/microbiome-age.types';
import styles from './SampleTooltip.module.css';

type SampleTooltipProps = {
  x: number;
  y: number;
  sample: MicrobiomeAgeSample | null;
};

// Headline = microbiome age; subline = sample date + chronological age.
export default function SampleTooltip({ x, y, sample }: SampleTooltipProps) {
  if (!sample) return null;

  return (
    <div className={styles.tooltip} style={{ top: y - 88, left: x - 92 }}>
      <Typography variant='heading-s' weight='medium' color='dark'>
        {Math.round(sample.microbiomeAge)} yrs old
      </Typography>
      <Typography variant='label' color='grey'>
        {format(parseDate(sample.sampleDate), 'MMM d, yyyy')} (
        {sample.age.toFixed(1)} yrs old)
      </Typography>
    </div>
  );
}
